import React from "react";
import SlideInOutAnimation from "../../util/SlideInOutAnimation";
import { FaDownload } from "react-icons/fa";
import CircularProgressBar from "../ux/CircularProgressBar";
import resume from "../../assets/file/Bijay_Pandey_resume.pdf";

function AboutMe() {
  const handleResumeDownload = () => {
    const link = document.createElement("a");
    link.href = resume;
    link.download = "Bijay_Pandey_resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section id="about" className="relative bg-black text-white px-6 py-20">
      {/* Section Title */}
      <SlideInOutAnimation>
        <h2 className="text-4xl font-bold text-center relative z-10 mb-14">
          ABOUT <span className="text-yellow-500">ME</span>
        </h2>
      </SlideInOutAnimation>

      {/* Main Content */}
      <div className="flex flex-col lg:flex-row justify-between gap-10 z-10 relative">
        {/* Personal Infos */}
        <SlideInOutAnimation className="w-full lg:w-1/2 grid grid-cols-2 gap-y-2 text-sm">
          <p>
            <strong>First Name:</strong> Bijay
          </p>
          <p>
            <strong>Last Name:</strong> Pandey
          </p>
          <p>
            <strong>Age:</strong> 25 <strong>Years</strong>
          </p>
          <p>
            <strong>Nationality:</strong> Indian
          </p>
          <p>
            <strong>Freelance:</strong>{" "}
            <span className="text-yellow-500">Not Available</span>
          </p>
          <p>
            <strong>Address:</strong> Kolkata, India
          </p>
          <p>
            <strong>Phone:</strong>{" "}
            <span className="text-yellow-500">Use email to contact</span>
          </p>
          <p>
            <strong>Email:</strong> cognisolver@gmail.com
          </p>
          <p>
            <strong>Alias:</strong> CogniSolver
          </p>
          <p>
            <strong>Languages:</strong>{" "}
            <strong>Hindi, English, Bengali, Bhojpuri</strong>
          </p>
          {/* Download Button spanning full width */}
          <div className="col-span-2 mt-4">
            <button
              onClick={handleResumeDownload}
              className="bg-yellow-500 text-black flex items-center justify-center gap-2 px-6 py-3 rounded-full font-semibold hover:bg-yellow-400 transition mx-auto"
            >
              <FaDownload />
              DOWNLOAD CV
            </button>
          </div>
        </SlideInOutAnimation>

        {/* Counters */}
        <SlideInOutAnimation className="w-full lg:w-1/2 grid grid-cols-2 gap-6">
          {[
            { value: "3+", label: "Years of Experience" },
            { value: "10+", label: "Completed Projects" },
            { value: "2+", label: "Brand Collab" },
            { value: "1400+", label: "YouTube Subs" },
          ].map((item, index) => (
            <div key={index} className="border border-gray-700 p-6 text-center">
              <h3 className="text-3xl font-bold text-yellow-500">
                {item.value}
              </h3>
              <div className="my-2 border-t border-gray-700 w-8 mx-auto"></div>
              <p className="text-gray-300 text-sm">{item.label}</p>
            </div>
          ))}
        </SlideInOutAnimation>
      </div>

      {/* Skills Section */}
      <SlideInOutAnimation className="mt-20 text-center">
        <h3 className="text-xl font-bold mb-10">MY SKILLS</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            ["Java", 90],
            ["Spring Boot", 90],
            ["React", 70],
            ["Angular", 75],
            ["DataBricks", 80],
            ["HTML", 100],
            ["JavaScript", 90],
            ["CSS", 90],
          ].map(([skill, percent], i) => (
            <div key={i} className="flex flex-col items-center">
              <CircularProgressBar
                percentage={percent}
                size={96}
                strokeWidth={6}
              />

              <p className="mt-3">{skill}</p>
            </div>
          ))}
        </div>
      </SlideInOutAnimation>
    </section>
  );
}

export default AboutMe;
